enum ConsentType {
  Admin = 'ADMIN',
  Email = 'EMAIL',
}

export default ConsentType;
